import { createTheme } from '@mui/material/styles'

// Module augmentation to extend theme structure for DataGrid
import type {} from '@mui/x-data-grid/themeAugmentation'

const theme = createTheme({
  palette: {
    primary: {
      main: '#16364F',
    },
    secondary: {
      main: '#F48026',
      light: '#F4BC3B',
    },
    info: {
      main: '#B1C5D9',
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    h1: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '2.5rem',
      fontWeight: 'bold',
      lineHeight: '1.1',
    },
    h2: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '1.875rem',
      fontWeight: 'bold',
      lineHeight: '1.33',
    },
    h3: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '1.5rem',
      fontWeight: 'normal',
      lineHeight: '1.5',
    },
    h4: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '1.25rem',
      fontWeight: 'normal',
      lineHeight: '1.8',
    },
    h5: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '1.125rem',
      fontWeight: 'bold',
      lineHeight: '1.56',
    },
    h6: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '0.875rem',
      lineHeight: '1.45',
      fontWeight: 'bold',
    },
    subtitle1: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '0.875rem',
      lineHeight: '1.45',
    },
    subtitle2: {
      fontFamily: '"Droid Sans", sans-serif',
      color: '#16364F',
      fontSize: '0.875rem',
      lineHeight: '1',
    },
    overline: {
      fontSize: '0.875rem',
      lineHeight: '1.15',
    },
    button: {
      letterSpacing: 'normal',
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'primary' && {
              backgroundColor: '#FFFFFF',
            }),
        }),
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          minWidth: 24,
          color: theme.palette.primary.main,
          '& svg': {
            fontSize: '1rem',
          },
        }),
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: '#FDF2D8',
          },
          '&.Mui-selected': {
            backgroundColor: '#fff',
            '&:hover': {
              backgroundColor: '#FDF2D8',
            },
            '& span': {
              fontWeight: 'bold',
            },
          },
          '& svg': {
            fontSize: '1rem',
          },
        }),
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: () => ({
          borderWidth: 0,
          '& .MuiDataGrid-virtualScrollerContent': {
            borderLeft: '1px solid rgba(224, 224, 224, 1)',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            borderTop: '3px solid rgba(224, 224, 224, 1)',
            borderBottom: '3px solid rgba(224, 224, 224, 1)',
          },
          '& .MuiTablePagination-root': {
            width: '100%',
          },
          '& .MuiTablePagination-spacer': {
            display: 'none',
          },
          '& .MuiTablePagination-displayedRows': {
            flex: 1,
            textAlign: 'center',
            color: theme.palette.secondary.main,
          },
          '& .MuiButtonBase-root': {
            color: theme.palette.secondary.main,
          },
          '& .MuiDataGrid-cell .MuiButtonBase-root': {
            color: theme.palette.primary.main,
          },
          '& .MuiTablePagination-select': {
            color: theme.palette.secondary.main,
          },
          '& .MuiTablePagination-selectIcon': {
            color: theme.palette.secondary.main,
          },
          '& .MuiTablePagination-toolbar': {
            paddingX: 4,
          },
          '& .MuiDataGrid-cell': {
            paddingX: 4,
          },
          '& .MuiDataGrid-columnHeader': {
            paddingX: 4,
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
        }),
        // Prevent outline on cell click
        cell: {
          outline: 'none !important',
        },
        columnHeader: {
          outline: 'none !important',
        },
      },
    },
  },
})

export default theme
